import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

import { Grid, Product, Title } from './styles'
import { Img } from '~/utils/styles'
import {
  formatTitle,
  getBackgroundColor,
  getReviewCount,
} from '~/utils/helpers'
import StarRating from '~/components/StarRating'
import Circle from '~/components/Circle'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  margin: 0 auto;
  position: relative;
  padding: 0 0 100px;
`

const Holder = styled.div`
  position: relative;

  &:before {
    content: '';
    display: block;
    padding-top: 148.62%;
  }

  .image {
    position: absolute !important;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(0%, -50%);
    object-fit: cover;
    left: 0;
  }
`

const RelatedProducts = ({ currentHandle }) => {
  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(sort: { fields: [createdAt], order: DESC }) {
          edges {
            node {
              id
              title
              handle
              createdAt
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 910) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
              tags
              variants {
                id
                title
                price
                availableForSale
                shopifyId
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    `
  )

  const products = allShopifyProduct.edges.filter(e => {
    return (
      e.node.handle !== currentHandle &&
      !e.node.tags.includes('wholesale') &&
      e.node.tags.includes('main-product')
    )
  })

  return (
    <Wrapper>
      <Grid count={products.length}>
        {products ? (
          products.map(
            ({
              node: {
                id,
                handle,
                title,
                images: [firstImage],
                variants,
                tags,
              },
            }) => {
              return (
                <Product key={id} className="product">
                  <Link to={`/products/${handle}/`}>
                    <Holder style={{ background: getBackgroundColor(handle) }}>
                      <Circle handle={handle} />
                      {firstImage && firstImage.localFile && (
                        <Img
                          fluid={firstImage.localFile.childImageSharp.fluid}
                          alt={handle}
                          style={{ marginBottom: 0 }}
                          className="image"
                        />
                      )}
                    </Holder>
                  </Link>
                  <Title
                    dangerouslySetInnerHTML={{ __html: formatTitle(title) }}
                  />
                  <div
                    style={{
                      margin: '10px 0',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <StarRating>{getReviewCount(handle)} reviews</StarRating>
                  </div>
                </Product>
              )
            }
          )
        ) : (
          <p>No Products found!</p>
        )}
      </Grid>
    </Wrapper>
  )
}

export default RelatedProducts
